import { schema } from 'normalizr';

export const countryCodeIsoSchema = new schema.Entity(
  'countryCodeIso',
  {},
  { idAttribute: 'iso' }
);
